import { Component, Inject, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { Subscription } from 'rxjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'sm-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.scss']
})
export class BookingDetailsComponent implements OnInit, OnDestroy {
  invoiceDetails: any = []
  private _apiSubscription: Subscription = new Subscription();
  bookingDetails: any = []
  @ViewChild('captureContainer', { static: false }) captureContainer!: ElementRef;
  constructor( @Inject(MAT_DIALOG_DATA) public parentData: any, private _apiService: ApiService) { }

  ngOnInit(): void { 
    console.log(this.parentData);
    
    let data = this.parentData.data
    
    this.bookingDetails = []
    this.bookingDetails.push(data)
    console.log(this.bookingDetails);
    

    this._apiSubscription =  this._apiService.apiResult.subscribe((resData) => {
      console.log("inInvoiceBookings3:", resData)
      if(resData.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_INVOICE_DETAILS){
        this.invoiceDetails = []
        if(resData.result && resData.result != null && resData.result != 'null'){
          this.invoiceDetails.push(resData.result[0])
          this.invoiceDetails[0].invoiceDetails = JSON.parse(this.invoiceDetails[0].invoiceDetails)
          this.invoiceDetails[0].date = new Date()
          console.log(this.invoiceDetails);
          
        }else {
          this._apiService.addEditEntityInvoice(data)
        }
        
      }
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_INVOICE_DETAILS){
        if (resData.result) {
          this._apiService.getEntityInvoiceDetails(data)
        } 
        
      }
    });
  }

  ngOnDestroy(): void {
    this._apiSubscription.unsubscribe()
  }

  captureScreenshot() {
    const element = document.getElementById('capture'); // Replace 'elementId' with the actual ID of the element you want to capture
    html2canvas(element!).then((canvas:any) => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      pdf.addImage(imgData, 'PNG', 0, 0, canvas.width * 0.75, canvas.height * 0.75); // You might need to adjust the dimensions
      pdf.save('screenshot.pdf');
    });
  }

  captureScreen() {

  //   html2canvas(this.captureContainer.nativeElement, {
  //     allowTaint : true,
  //     useCORS : true 
  //  }).then(canvas => {
  //     // Convert canvas to an image URL
  //     const screenshotUrl = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF();
  //     pdf.addImage(screenshotUrl, 'PNG', 0, 0, canvas.width * 1, canvas.height * 1); // You might need to adjust the dimensions
  //     pdf.save('screenshot.pdf');
  //   });

  let pdf = new jsPDF('p', 'pt', 'a4')
  pdf.html(this.captureContainer.nativeElement, { callback:(pdf) => {
pdf.save("sample.pdf")
  } 
})


  }

}